<template>
  <!-- 表格说明： 此表格主要为基本表格，且为最常用的表格，兼具基本表格的功能：复选框，编辑列，表格列中内容有点击事件-->
  <div
    class="table-content reportTableCont"
    :style="{'height':(tableData.options.tableHeight+'px')}"
  >
    <el-table
      :data="tableData.list"
      ref="multipleTableRef"
      border
      fit
      :show-summary="tableData.options.showSummary"
      :summary-method="getSummaries"
      :max-height="tableData.options.tableHeight"
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="empty-box mt20 mb20">
          <i class="mh-kym_icon icon"></i>
          <p
            class="col-66 text-1"
          >{{tableData.options.errortip!=''?tableData.options.errortip:$t('components.tables.reportTableCont.51h4zidgd4o0')}}</p>
        </div>
      </template>
      <!-- //表格多选是否存在判断 -->
      <el-table-column
        v-if="tableData.options.mutiSelect && tableData.options.selectDisable"
        type="selection"
        align="center"
        style="width: 55px;"
        :selectable="checkboxInit"
        fixed="left"
      ></el-table-column>
      <el-table-column
        v-else-if="tableData.options.mutiSelect"
        type="selection"
        align="center"
        style="width: 55px;"
        fixed="left"
      ></el-table-column>
      <!-- 表格数据渲染 -->
      <template v-for="(column,$index) in tableData.columns">
        <!-- 固定列 -->
        <template v-if="$index==IndexId || $index==IndexIdTwo ||$index==0">
          <el-table-column
            :prop="column.fieldstring"
            :key="$index"
            fixed="left"
            :sortable="column.sortable"
            :label="column.fieldname"
            align="center"
            :min-width="column.width?column.width:'150px'"
            :show-overflow-tooltip="true"
            v-if="column.show=='1'"
          >
            <template slot-scope="scope">
              <el-button
                v-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index,column,scope.row)"
              >{{tableData.list[scope.$index][column.fieldstring]}}</el-button>
              <span v-else type="text" v-html="tableData.list[scope.$index][column.fieldstring]"></span>
            </template>
          </el-table-column>
        </template>
        <!-- 一般列 -->
        <template v-else>
          <el-table-column
            :prop="column.fieldstring"
            :key="$index"
            :label="column.fieldname"
            :sortable="column.sortable"
            align="center"
            :min-width="column.width?column.width:'150px'"
            :show-overflow-tooltip="true"
            v-if="column.show=='1'"
          >
            <template slot-scope="scope">
             <el-button
                v-if="column.ismethod && !scope.row.not_click"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index,column,scope.row)"
              >{{tableData.list[scope.$index][column.fieldstring]}}</el-button>
              <span v-else-if="column.ismethod && scope.row.not_click" type="text" v-html="tableData.list[scope.$index][column.fieldstring]"></span>
              <span v-else type="text" v-html="tableData.list[scope.$index][column.fieldstring]"></span>
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 操作列 -->
      <slot></slot>
      <!-- 编辑列 -->
      <el-table-column
        fixed="right"
        label
        align="center"
        width="40px"
        v-if="tableData.options.issetting"
        :render-header="renderHeader"
      ></el-table-column>
    </el-table>
    <!-- 穿梭框 -->
    <el-dialog
      :title="$t('components.tables.reportTableCont.51h4zidgeow0')"
      class="setting-box setting-column"
      :visible.sync="dialogVisible"
      width="450px"
    >
      <el-transfer v-model="oprateColumn" :data="data" :titles="[$t('components.tables.reportTableCont.51h4zidgf480'), $t('components.tables.reportTableCont.51h4zidgfgc0')]"></el-transfer>
      <div class="oprate">
        <el-button size="small" type="primary" @click="handSetting()">{{$t('components.tables.reportTableCont.51h4zidgfsg0')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "reportTableCont",
  props: {
    // 表格数据所有参数
    tableData: {
      type: Object
    }
  },
  data() {
    return {
      dialogVisible: false,
      showColumns: [],
      data: [],
      oprateColumn: [], //编辑列
      IndexId: -1, //固定的列数
      IndexIdTwo: -1 //固定的列数
    };
  },
  created() {
    this.getColums();
    this.toggleSelection(this.tableData.multipleTable);
  },
  watch: {
    getIndex(n, o) {
      (() => {})(n);
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (n.length >= 8) {
        n.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
      (() => {})(this.IndexId);
      // 编辑列操作
      if (this.tableData.options.issetting) {
        var fieldColumns = n;
        if (
          !this.$Tool.getStorage("module" + [this.tableData.options.moduleName])
        ) {
          this.$Tool.setStorage(
            "module" + [this.tableData.options.moduleName],
            {}
          );
        }
        var obj = this.$Tool.getStorage(
          "module" + [this.tableData.options.moduleName]
        );
        obj["all_" + [this.tableData.options.ColumnName]] = n;
        // obj["show_" + [this.tableData.options.ColumnName]] = n;
        this.$Tool.setStorage(
          "module" + [this.tableData.options.moduleName],
          obj
        );
        if (obj["show_" + [this.tableData.options.ColumnName]]) {
          fieldColumns = obj["show_" + [this.tableData.options.ColumnName]];
        }
        // 自定义编辑列
        var settingOprateData = this.$Tool.settingOprateData(fieldColumns);
        this.data = settingOprateData.data;
        this.oprateColumn = settingOprateData.oprateColumn;
      }
      (() => {})(this.data,1213133)
    },
    getmultipleTable(n, o) {
      (() => {})(n, n[1], n[2]);
      this.toggleSelection(n);
    }
  },
  computed: {
    getIndex() {
      return this.tableData.columns;
    },
    getmultipleTable() {
      return this.tableData.multipleTable;
    }
  },
  methods: {
    getColums() {
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (this.tableData.columns.length >= 8) {
        this.tableData.columns.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
    },
    // 总计统计
    getSummaries(param) {
      if (this.tableData.options.showSummary) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$t(
              "components.tables.reportTableCont.510zlzbr2gg0"
            );
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if (sums[index] && sums[index].toString().split(".")[1]) {
              sums[index] = Math.floor(sums[index] * 100) / 100;
            } else {
              (() => {})("1121213213");
              sums[index] = sums[index] + ".00";
            }
          } else {
            sums[index] = "";
          }
        });
        return sums;
      }
    },
    // 复选框控制权限
    checkboxInit(row, index) {
      (() => {})(row, index);
      return 0; //不可勾选
      // if (row.withdrawState==2)//这个判断根据你的情况而定
      // return 0;//不可勾选
      // else
      // return 1;//可勾选
      // },
    },
    // 编辑列渲染
    renderHeader(h, { column, $index }) {
      (() => {})(
        h,
        column,
        $index,
        this.$t("components.tables.reportTableCont.510zlzbr2ko0")
      );
      return h("i", {
        class: "el-icon-setting btn-setting",
        on: {
          click: () => {
            this.dialogVisible = true;
          }
        }
      });
    },
    // 表格内容绑定事件
    handleColumnChange(k, v, column) {
      // (() => {})(k, v, column);
      this.$emit("handleColumnChange", k, v, column);
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    // 编辑列提交
    handSetting() {
      let obj = this.$Tool.getStorage(
        "module" + [this.tableData.options.moduleName]
      );
      let allnum = obj["all_" + [this.tableData.options.ColumnName]];
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item, index) => {
        allnum[parseInt(item)].show = "0";
      });
      (() => {})(this.oprateColumn, 12131);
      this.showColumns = allnum;
      obj["show_" + [this.tableData.options.ColumnName]] = this.showColumns;
      this.$Tool.setStorage(
        "module" + [this.tableData.options.moduleName],
        obj
      );
      this.$emit("handSetting", this.showColumns);
      this.dialogVisible = false;
    },
    // 多选默认选中的状态
    toggleSelection(rows) {
      (() => {})(rows, 12233);
      //   是否默认选中
      if (this.tableData.options.mutiSelect && rows && rows.length > 0) {
        let multipleInfoData = this.tableData.multipleTable;
        this.$nextTick(() => {
          rows.forEach(row => {
            (() => {})(row);
            multipleInfoData.forEach((item, index2) => {
              if (row.student_id == item.student_id) {
                this.$refs.multipleTableRef.toggleRowSelection(row, true);
              }
            });
          });
        });
      } else {
        this.clear();
      }
    },
    // 多选清除选中的状态
    clear() {
      this.$nextTick(() => {
        this.$refs.multipleTableRef.clearSelection();
      });
    }
  }
};
</script>
<style lang="less">
.btn-setting {
  display: block;
  width: 20px;
  height: 20px;
  font-size: 16px;
  margin: 0 auto;
  color: #aaa;
  // background-color: green;
  cursor: pointer;
}
.reportTableCont {
  .setting-box {
    //编辑列样式
    .el-button--medium {
      padding: 6px 6px !important;
    }

    .el-transfer__buttons {
      padding: 0 10px;
    }

    .el-transfer__button:nth-child(2) {
      margin-left: 5px !important;
    }

    .el-transfer-panel {
      width: 178px;
    }
    .oprate {
      position: absolute;
      width: 56px;
      top: 10px;
      right: 50px;
    }
  }
}
</style>
